exports = module.exports = require("../../../../../../../web-hosted/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".TaskGroup__TaskGroup__1VqwV {\n  width: 90%;\n  /* background-color: rgba(0,0,0,0.1); */\n  margin: 20px 20px;\n  padding: 0px;\n}\n\n.TaskGroup__Header__3hQOa {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.TaskGroup__HeaderName__25xyq {\n  font-weight: 600;\n}\n\n.TaskGroup__ConfigureIcon__1oHJE {\n  font-size: 1.30rem;\n  margin-right: 15px;\n}\n\n.TaskGroup__TaskCards__pUMr7 {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-align: start;\n      align-items: flex-start;\n}", ""]);

// exports
exports.locals = {
	"TaskGroup": "TaskGroup__TaskGroup__1VqwV",
	"Header": "TaskGroup__Header__3hQOa",
	"HeaderName": "TaskGroup__HeaderName__25xyq",
	"ConfigureIcon": "TaskGroup__ConfigureIcon__1oHJE",
	"TaskCards": "TaskGroup__TaskCards__pUMr7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/containers/Mainpage/containers/AllTasksPage/TaskGroup/TaskGroup.css
// module id = 624
// module chunks = 0